import DialogPopupAbstract from "components/DialogPopupAbstract";

import Button from "components/Button";
import SexSelect from "components/SexSelect";
import RadioBlock from "components/RadioBlock";
import AreaExpande from "components/AreaExpande";

import { ReactComponent as CloseIcon } from 'icons/close.svg';

import './index.less';
import './themes/default.less';

export default class RightPopup extends DialogPopupAbstract {
    constructor(props) {
        super(props);

        this.state = {
            opened: false
        };

        this.useTooltip = true;
    }

    get popupName() {
        return "";
    }

    get dialogTitle() {
        return this.title?.toUpperCase ? this.tr(this.title) : (this.title || "");
    }

    set dialogTitle(value) {
        this.title = value;
    }

    get dialogSaveTitle() {
        return this.saveTitle;
    }

    set dialogSaveTitle(value) {
        this.saveTitle = value;
    }

    componentDidMount() {
        this.checkOver();

        super.componentDidMount();
    }

    componentDidUpdate() {
        this.checkOver();

        super.componentDidUpdate();
    }

    componentWillUnmount() {
        this.clearCnts();
    }

    checkOver() {
        if (!this.contentNode)
            return;

        const { offsetHeight, scrollHeight } = this.contentNode;

        this._helper.dom.addRemoveClass(this.domNode, "hasScroll", scrollHeight > offsetHeight);
    }

    setOpenedState(opened, cb) {
        this.setState({ opened }, () => {
            if (opened)
                this.setActive();
            cb();
        });
    }

    setActive() {
        const tm = setTimeout(() => {
            clearTimeout(tm);
            this._helper.dom.addClass(this.domNode, "active");
        }, 10);
    }

    checkHide(e) {
        if (e.key === "Escape")
            this.hide();
    }

    clearCnts() {
        this._helper.disconnect(this.keyCnt);
    }

    show() {
        this.setOpenedState(true, this.onShow.bind(this));

        this.clearCnts();
        this.keyCnt = this._helper.on(window, "keyup", this.checkHide.bind(this));
    }

    hide() {
        this.clearCnts();

        this.setOpenedState(false, this._onHide.bind(this));
    }

    onShow() {

    }

    _onHide() {
        if (this.defaultState)
            this.setState({ ...this.defaultState });

        this.onHide();
    }

    onHide() {

    }

    save() {

    }

    insertSexSelect(props) {
        return <SexSelect {...props} />;
    }

    insertContentTitle(text) {
        return (
            <div className="contentTitle text blockTitle">
                {this.tr(text)}
            </div>
        );
    }

    insertAreaInput(props) {
        return <AreaExpande {...props} />;
    }

    insertRowText(rowText) {
        return (
            <div className="rowText text p2">
                {this.tr(rowText)}
            </div>
        );
    }

    insertRowInfo(title, value) {
        const val = value ? value : "main.choose";
        return (
            <div className="rowInfo text p1 flex gap16">
                <div className="rowInfoTitle">{this.tr(title)}</div>
                <div className={`rowInfoValue hand ${value ? "" : "choose"}`}>
                    {this.tr(val)}
                </div>
            </div>
        );
    }

    insertParagraf(rowText) {
        return (
            <div className="paragraf text p1SemiBold">
                {this.tr(rowText)}
            </div>
        );
    }

    insertRadioBlock(props) {
        return <RadioBlock {...props} />;
    }

    insertLine() {
        return (
            <div className="line" />
        );
    }

    renderContent() {
        return <></>;
    }

    renderLeftButtons() {
        return <></>;
    }

    renderButtons() {
        const saveLabel = this.dialogSaveTitle || "main.save";

        return (
            <div className="buttons flex between">
                <div className="flex gap16">
                    {this.renderLeftButtons()}
                </div>
                <div className="flex gap16">
                    <Button
                        label="main.cancel"
                        size="small"
                        type="transparent"
                        onClick={this.hide.bind(this)}
                    />
                    <Button
                        label={saveLabel}
                        size="small"
                        onClick={this.save.bind(this)}
                    />
                </div>
            </div>
        );
    }

    render() {
        if (!this.state.opened)
            return <></>;

        return (
            <div
                className={`rightPopup ${this.popupName}  pos fixed sideAll flex end transit025`}
                ref={el => this.domNode = el}
            >
                <div className="form flex col transit06">
                    <div className="title flex centerV">
                        <div className="flex1 text windowTitle">{this.dialogTitle}</div>
                        {this.dialogTitle?.toUpperCase ?
                            <CloseIcon className="close hand" onClick={this.hide.bind(this)} /> : <div></div>}
                    </div>
                    <div ref={el => this.contentNode = el} className="scrolling rightPopupScroll">
                        {this.renderContent()}
                    </div>
                    {this.renderButtons()}
                </div>
            </div>
        );
    }
}
